export default __webpack_public_path__ + "static/ISP_SP_kolor-d7461a23b8f3918a9d650095305a8ed5.png";